import { IJsonQueryPolygon } from '../../../packages/api-models/common/json_query';
import { getGeoValue, TGeoValue, TJsonQuery } from '../../../packages/JsonQuery';

export function addPolygonToJsonQuery(jsonQuery: TJsonQuery, polygon: IJsonQueryPolygon): TGeoValue[] {
  const geoValue = getGeoValue()(jsonQuery);

  return geoValue?.concat([polygon]) ?? [polygon];
}
